'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serialize = function serialize(obj) {
  return Object.keys(obj).reduce(function (a, k) {
    return obj[k] && a.push(k + '=' + encodeURIComponent(obj[k])) && a || a;
  }, []).join('&');
};

var NavButtons = function NavButtons(_ref) {
  var Link = _ref.Link,
      params = _ref.params,
      path = _ref.path,
      after = _ref.after,
      before = _ref.before,
      count = _ref.count,
      limit = _ref.limit;
  return after || before ? _react2.default.createElement(
    'div',
    { className: 'nav-buttons' },
    _react2.default.createElement(
      'span',
      { className: 'nextprev' },
      "view more: ",
      before && _react2.default.createElement(
        Link,
        {
          rel: 'nofollow prev',
          href: path + '?' + serialize(_extends({}, params, { before: before, count: count + 1, after: "" }))
        },
        '\u2039 prev'
      ),
      after && before && _react2.default.createElement('span', { className: 'separator' }),
      after && _react2.default.createElement(
        Link,
        {
          rel: 'nofollow next',
          href: path + '?' + serialize(_extends({}, params, { after: after, count: count + limit, before: "" }))
        },
        'next \u203A'
      )
    )
  ) : null;
};

exports.default = NavButtons;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/NavButtons.js
// module id = 311
// module chunks = 0